/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { GetQuizSetSitemapEntriesByCountryCodeParams } from '../_model/getQuizSetSitemapEntriesByCountryCodeParams';
import type { GetQuizsetSummaryParams } from '../_model/getQuizsetSummaryParams';
import type { GetQuizsetTitleParams } from '../_model/getQuizsetTitleParams';
import type { GetTopPlayedQuizsetsParams } from '../_model/getTopPlayedQuizsetsParams';
import type { QuizsetPlayCountBulkReq } from '../_model/quizsetPlayCountBulkReq';
import type { SuccessBody } from '../_model/successBody';
import type { SuccessBodyListQuizsetPlayCountResult } from '../_model/successBodyListQuizsetPlayCountResult';
import type { SuccessBodyListString } from '../_model/successBodyListString';
import type { SuccessBodyQuizSetIdsRes } from '../_model/successBodyQuizSetIdsRes';
import type { SuccessBodyQuizsetSummaryDto } from '../_model/successBodyQuizsetSummaryDto';
import type { SuccessBodySeoSitemapPageSitemapEntry } from '../_model/successBodySeoSitemapPageSitemapEntry';
import type { SuccessBodyString } from '../_model/successBodyString';
import type { UpdatePlayCountParams } from '../_model/updatePlayCountParams';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * 하위호환을 위해 유지합니다. 신규 호출은 POST /quizsets/play-count/bulk 를 사용하세요.
 * @deprecated
 * @summary 퀴즈셋 플레이 카운트 증가 (Deprecated)
 */
export const updatePlayCount = (
  params: UpdatePlayCountParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/quizsets/play-count`, method: 'POST', params, signal },
    options,
  );
};

export const getUpdatePlayCountMutationKey = () => ['updatePlayCount'] as const;

export const getUpdatePlayCountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlayCount>>,
    TError,
    UpdatePlayCountMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlayCount>>,
  TError,
  UpdatePlayCountMutationVariables,
  TContext
> => {
  const mutationKey = getUpdatePlayCountMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlayCount>>,
    UpdatePlayCountMutationVariables
  > = props => {
    const { params } = props ?? {};

    return updatePlayCount(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlayCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlayCount>>
>;

export type UpdatePlayCountMutationError = ErrorType<unknown>;
export type UpdatePlayCountMutationVariables = {
  params: UpdatePlayCountParams;
};

/**
 * @deprecated
 * @summary 퀴즈셋 플레이 카운트 증가 (Deprecated)
 */
export const useUpdatePlayCount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlayCount>>,
      TError,
      UpdatePlayCountMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlayCount>>,
  TError,
  UpdatePlayCountMutationVariables,
  TContext
> => {
  return useMutation(getUpdatePlayCountMutationOptions(options), queryClient);
};
export const updatePlayCountBulk = (
  quizsetPlayCountBulkReq: BodyType<QuizsetPlayCountBulkReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBody>(
    {
      url: `/quizsets/play-count/bulk`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetPlayCountBulkReq,
      signal,
    },
    options,
  );
};

export const getUpdatePlayCountBulkMutationKey = () =>
  ['updatePlayCountBulk'] as const;

export const getUpdatePlayCountBulkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlayCountBulk>>,
    TError,
    UpdatePlayCountBulkMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlayCountBulk>>,
  TError,
  UpdatePlayCountBulkMutationVariables,
  TContext
> => {
  const mutationKey = getUpdatePlayCountBulkMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlayCountBulk>>,
    UpdatePlayCountBulkMutationVariables
  > = props => {
    const { data } = props ?? {};

    return updatePlayCountBulk(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlayCountBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlayCountBulk>>
>;
export type UpdatePlayCountBulkMutationBody = BodyType<QuizsetPlayCountBulkReq>;
export type UpdatePlayCountBulkMutationError = ErrorType<unknown>;
export type UpdatePlayCountBulkMutationVariables = {
  data: BodyType<QuizsetPlayCountBulkReq>;
};

export const useUpdatePlayCountBulk = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlayCountBulk>>,
      TError,
      UpdatePlayCountBulkMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlayCountBulk>>,
  TError,
  UpdatePlayCountBulkMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdatePlayCountBulkMutationOptions(options),
    queryClient,
  );
};
export const getTopPlayedQuizsets = (
  params: GetTopPlayedQuizsetsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListQuizsetPlayCountResult>(
    { url: `/quizsets/top-play-counts`, method: 'GET', params, signal },
    options,
  );
};

export const getGetTopPlayedQuizsetsQueryKey = (
  params?: GetTopPlayedQuizsetsParams,
) => {
  return [`/quizsets/top-play-counts`, ...(params ? [params] : [])] as const;
};

export const getGetTopPlayedQuizsetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopPlayedQuizsetsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopPlayedQuizsets>>
  > = ({ signal }) => getTopPlayedQuizsets(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTopPlayedQuizsetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopPlayedQuizsets>>
>;
export type GetTopPlayedQuizsetsQueryError = ErrorType<unknown>;

export function useGetTopPlayedQuizsets<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
          TError,
          Awaited<ReturnType<typeof getTopPlayedQuizsets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTopPlayedQuizsets<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
          TError,
          Awaited<ReturnType<typeof getTopPlayedQuizsets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTopPlayedQuizsets<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTopPlayedQuizsets<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTopPlayedQuizsetsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTopPlayedQuizsetsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopPlayedQuizsetsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopPlayedQuizsets>>
  > = ({ signal }) => getTopPlayedQuizsets(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetTopPlayedQuizsetsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopPlayedQuizsets>>
>;
export type GetTopPlayedQuizsetsSuspenseQueryError = ErrorType<unknown>;

export function useGetTopPlayedQuizsetsSuspense<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTopPlayedQuizsetsSuspense<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTopPlayedQuizsetsSuspense<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTopPlayedQuizsetsSuspense<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTopPlayedQuizsetsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getQuizsetTitle = (
  params: GetQuizsetTitleParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyString>(
    { url: `/quizsets/title`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizsetTitleQueryKey = (params?: GetQuizsetTitleParams) => {
  return [`/quizsets/title`, ...(params ? [params] : [])] as const;
};

export const getGetQuizsetTitleQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizsetTitleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizsetTitle>>> = ({
    signal,
  }) => getQuizsetTitle(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetTitle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizsetTitleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetTitle>>
>;
export type GetQuizsetTitleQueryError = ErrorType<unknown>;

export function useGetQuizsetTitle<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetTitle>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetTitle>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetTitle<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetTitle>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetTitle>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetTitle<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizsetTitle<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizsetTitleQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizsetTitleSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizsetTitleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizsetTitle>>> = ({
    signal,
  }) => getQuizsetTitle(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetTitle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizsetTitleSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetTitle>>
>;
export type GetQuizsetTitleSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizsetTitleSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetTitleSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetTitleSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizsetTitleSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizsetTitleSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getQuizsetSummary = (
  params: GetQuizsetSummaryParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetSummaryDto>(
    { url: `/quizsets/summary`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizsetSummaryQueryKey = (
  params?: GetQuizsetSummaryParams,
) => {
  return [`/quizsets/summary`, ...(params ? [params] : [])] as const;
};

export const getGetQuizsetSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetSummary>>
  > = ({ signal }) => getQuizsetSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizsetSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetSummary>>
>;
export type GetQuizsetSummaryQueryError = ErrorType<unknown>;

export function useGetQuizsetSummary<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetSummary>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetSummary<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetSummary>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetSummary<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizsetSummary<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizsetSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizsetSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetSummary>>
  > = ({ signal }) => getQuizsetSummary(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizsetSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetSummary>>
>;
export type GetQuizsetSummarySuspenseQueryError = ErrorType<unknown>;

export function useGetQuizsetSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizsetSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizsetSummarySuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getQuizSetSitemapEntriesByCountryCode = (
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodySeoSitemapPageSitemapEntry>(
    { url: `/quizsets/sitemap-entries`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizSetSitemapEntriesByCountryCodeQueryKey = (
  params?: GetQuizSetSitemapEntriesByCountryCodeParams,
) => {
  return [`/quizsets/sitemap-entries`, ...(params ? [params] : [])] as const;
};

export const getGetQuizSetSitemapEntriesByCountryCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetQuizSetSitemapEntriesByCountryCodeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
  > = ({ signal }) =>
    getQuizSetSitemapEntriesByCountryCode(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizSetSitemapEntriesByCountryCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
>;
export type GetQuizSetSitemapEntriesByCountryCodeQueryError =
  ErrorType<unknown>;

export function useGetQuizSetSitemapEntriesByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetSitemapEntriesByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetSitemapEntriesByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizSetSitemapEntriesByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizSetSitemapEntriesByCountryCodeQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizSetSitemapEntriesByCountryCodeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetQuizSetSitemapEntriesByCountryCodeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
  > = ({ signal }) =>
    getQuizSetSitemapEntriesByCountryCode(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizSetSitemapEntriesByCountryCodeSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
  >;
export type GetQuizSetSitemapEntriesByCountryCodeSuspenseQueryError =
  ErrorType<unknown>;

export function useGetQuizSetSitemapEntriesByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetSitemapEntriesByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetSitemapEntriesByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizSetSitemapEntriesByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetQuizSetSitemapEntriesByCountryCodeSuspenseQueryOptions(
      params,
      options,
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getQuizSetSitemapCountries = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListString>(
    { url: `/quizsets/sitemap-countries`, method: 'GET', signal },
    options,
  );
};

export const getGetQuizSetSitemapCountriesQueryKey = () => {
  return [`/quizsets/sitemap-countries`] as const;
};

export const getGetQuizSetSitemapCountriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizSetSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
  > = ({ signal }) => getQuizSetSitemapCountries(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizSetSitemapCountriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
>;
export type GetQuizSetSitemapCountriesQueryError = ErrorType<unknown>;

export function useGetQuizSetSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizSetSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizSetSitemapCountriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizSetSitemapCountriesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizSetSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
  > = ({ signal }) => getQuizSetSitemapCountries(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizSetSitemapCountriesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
>;
export type GetQuizSetSitemapCountriesSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizSetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizSetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetQuizSetSitemapCountriesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getQuizSetIds = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizSetIdsRes>(
    { url: `/quizsets/ids`, method: 'GET', signal },
    options,
  );
};

export const getGetQuizSetIdsQueryKey = () => {
  return [`/quizsets/ids`] as const;
};

export const getGetQuizSetIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizSetIdsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizSetIds>>> = ({
    signal,
  }) => getQuizSetIds(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizSetIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetIds>>
>;
export type GetQuizSetIdsQueryError = ErrorType<unknown>;

export function useGetQuizSetIds<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetIds>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetIds>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetIds<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetIds>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetIds>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetIds<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizSetIds<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizSetIdsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizSetIdsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getQuizSetIds>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizSetIdsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizSetIds>>> = ({
    signal,
  }) => getQuizSetIds(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizSetIdsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetIds>>
>;
export type GetQuizSetIdsSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizSetIdsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetIdsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizSetIdsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizSetIdsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizSetIdsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
